"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestNavigationKeys = void 0;
const react_1 = require("react");
const NavigationKeyManager_1 = require("../../core/managers/NavigationKeyManager");
/**
 * A React hook to request a specific keyboard navigation keys and release it when the component is unmounted.
 *
 * When invoked, the hook automatically requests the specified navigation keys for the component
 * and ensures that these are released when the component is unmounted or when a different
 * key set is requested. The hook uses a unique ID for each component instance to keep
 * track of the requested keys.
 *
 * @param keys - The desired keyboard keys to be requested.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *     useRequestNavigationKeys([KeyboardKey.ArrowUp, KeyboardKey.ArrowDown]);
 *
 *     // rest of the component
 * }
 * ```
 *
 * @returns {void}
 */
const useRequestNavigationKeys = (keys) => {
    const id = (0, react_1.useId)();
    (0, react_1.useEffect)(() => {
        NavigationKeyManager_1.NavigationKeyManager.requestKeys(id, keys);
        return () => {
            NavigationKeyManager_1.NavigationKeyManager.releaseKeys(id);
        };
    }, [keys]);
};
exports.useRequestNavigationKeys = useRequestNavigationKeys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVxdWVzdE5hdmlnYXRpb25LZXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3V0aWxpdHkvdXNlUmVxdWVzdE5hdmlnYXRpb25LZXlzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCxpQ0FBeUM7QUFFekMsbUZBQWdGO0FBRWhGOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQW9CRztBQUNJLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFtQixFQUFFLEVBQUU7SUFDNUQsTUFBTSxFQUFFLEdBQUcsSUFBQSxhQUFLLEdBQUUsQ0FBQztJQUVuQixJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ1gsMkNBQW9CLENBQUMsV0FBVyxDQUFDLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQztRQUUzQyxPQUFPLEdBQUcsRUFBRTtZQUNSLDJDQUFvQixDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUN6QyxDQUFDLENBQUM7SUFDTixDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBVlcsUUFBQSx3QkFBd0IsNEJBVW5DIn0=